/*jslint nomen: true */
/*global cjs,esprima,_,able,uid */

var interstate = (function (root) {
    "use strict";
	var ist = {
		cjs: cjs.noConflict(),
		_: _.noConflict(),
		esprima: esprima,
		version: "0.1.0",
		build_time: "2026-09-27T00:36:02.811Z",
		__log_errors: true,
		// Incomplete expressions are normal while editing; report them in the UI.
		__debug: false,
		__empty_files: false,
		__garbage_collect: true,
		root_name: "sketch"
	};

	// Statechart views require the reactive state fields enabled by this flag.
	ist.__debug_statecharts = true;

	able.make_this_listenable(ist);
	able.make_proto_listenable(ist);

	var uid_objs = {};
	ist.register_uid = function (id, obj) {
		uid_objs[id] = obj;
		ist._emit("uid_registered", id, obj);
	};
	ist.unregister_uid = function (id) {
		delete uid_objs[id];
		ist._emit("uid_unregistered", id);
	};
	ist.find_uid = function (uid) { return uid_objs[uid]; };


	var valid_prop_name_regex = /^[a-zA-Z_$][0-9a-zA-Z_$]*$/;
	ist.is_valid_prop_name = function(name) {
		return name.match(valid_prop_name_regex);
	};

	ist.async_js = function(url, cback) {
		var doc = root.document,
		type = 'script',
		node = doc.createElement(type),
		head = doc.getElementsByTagName('head')[0];

		node.type = 'text/javascript';
		node.src = url;
		if (cback) { node.addEventListener('load', function (e) { cback(e); }, false); }
		head.appendChild(node);
	};

	return ist;
}(this));
